// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/stock_movement_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ItemType, StockMovementReportItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.StockMovementReportRequest
 */
export class StockMovementReportRequest extends Message<StockMovementReportRequest> {
  /**
   * Year for which the stock movement report is generated
   *
   * @generated from field: int32 year = 1;
   */
  year = 0;

  /**
   * ID of the inventory item for which to generate the stock movement report
   *
   * @generated from field: string master_id = 2;
   */
  masterId = "";

  /**
   * Type of the inventory item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 3;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<StockMovementReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockMovementReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockMovementReportRequest {
    return new StockMovementReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockMovementReportRequest {
    return new StockMovementReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockMovementReportRequest {
    return new StockMovementReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StockMovementReportRequest | PlainMessage<StockMovementReportRequest> | undefined, b: StockMovementReportRequest | PlainMessage<StockMovementReportRequest> | undefined): boolean {
    return proto3.util.equals(StockMovementReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockMovementReportResponse
 */
export class StockMovementReportResponse extends Message<StockMovementReportResponse> {
  /**
   * List of stock movement report items
   *
   * @generated from field: repeated com.neulink.pharmacy.StockMovementReportItem items = 1;
   */
  items: StockMovementReportItem[] = [];

  constructor(data?: PartialMessage<StockMovementReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockMovementReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: StockMovementReportItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockMovementReportResponse {
    return new StockMovementReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockMovementReportResponse {
    return new StockMovementReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockMovementReportResponse {
    return new StockMovementReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StockMovementReportResponse | PlainMessage<StockMovementReportResponse> | undefined, b: StockMovementReportResponse | PlainMessage<StockMovementReportResponse> | undefined): boolean {
    return proto3.util.equals(StockMovementReportResponse, a, b);
  }
}

